export default "__VITE_ASSET__BqDjZWLo__"